import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   COLOSSE — le gros rocher INDESTRUCTIBLE. On ne le tue pas, on l'évite.

   `destructible: false` : aucune arme ne l'entame, ses tirs s'y écrasent en
   pure perte. C'est une vraie source de difficulté, pas un sac de PV : il change
   la NATURE de la menace. Un mur de PV se résout en tirant plus fort ; un rocher
   qu'on ne peut pas casser se résout en BOUGEANT — il découpe le terrain, ferme
   une moitié de l'écran, force un couloir. C'est le pendant décor du Mortier
   (Motion.Anchor), qui bascule d'« adversaire » à « obstacle » : ici l'obstacle
   est là d'emblée, et il ne fait jamais semblant d'être une cible.

   `hp` est posé mais inerte (le drapeau prime) : une valeur nominale plutôt que
   zéro, pour qu'un futur mode « rocher fragilisable » n'ait qu'à basculer le
   drapeau sans réécrire les PV.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'astero-colosse',
  radius: 82,
  hp: 1,
  destructible: false,
});
